import {useMutation, useQuery, useQueryClient} from "@tanstack/react-query";
import AxiosInstance from "../../components/Axios";
import {MRT_ColumnFiltersState, MRT_PaginationState, MRT_SortingState} from "material-react-table";
import {NC, NCDTOApiResponse} from "./types";
import {columnFiltersParamWithDateRange2, sortingParam2} from "../../common/Services";
import * as Yup from "yup";
import {DropAttivitaApiResponse} from "../../common/types";


const moment = require('moment')

export function useGetNCDTO(
    pagination: MRT_PaginationState,
    columnFilters: MRT_ColumnFiltersState,
    globalFilter: string,
    sorting: MRT_SortingState,
 ) {
    return useQuery<NCDTOApiResponse>({
        queryKey: [
            'fetchNCDTO',
            columnFilters,
            globalFilter,
            pagination.pageIndex,
            pagination.pageSize,
            sorting,

        ],
        queryFn: async () => {

            let coddip = localStorage.getItem('coddip') || '';
            const keyrole = localStorage.getItem('keyrole') || '';

            const isAdmin =  keyrole.includes('TimeReportAdmin') ;

            const myLimit=pagination.pageSize
            const myOffset =
                pagination.pageIndex === 0
                    ? '0'
                    : `${pagination.pageSize * pagination.pageIndex}`;

            let myURL = `?limit=${myLimit}&offset=${myOffset}&search=${globalFilter ?? ''}${columnFiltersParamWithDateRange2(
                columnFilters
            )}&ordering=${sortingParam2(sorting)}`;




            if (!isAdmin) {
                        myURL += `&coddip=${coddip}`;
                }


            // console.log('myURL',myURL);

            const response = await AxiosInstance.get(`ncdto/${myURL}`);

            return response.data;
        },
        refetchOnWindowFocus: false,
    });
}



export function useGetNC(idnc: number) {
  return useQuery<NC>({
    queryKey: ['fetchNC', idnc],
    queryFn: async () => {
      const response = await AxiosInstance.get('nc/' + idnc + '/');


      const transformedData = response.data?.data?.NC;



      return transformedData;
    },
    refetchOnWindowFocus: false,
  });
}






export function useCreateNC() {
  const queryClient = useQueryClient();
  return useMutation({

    mutationFn: async (NC: NC) => {
      if (NC.dataapertura) {
        NC.dataapertura = moment(NC.dataapertura).format('YYYY-MM-DD');
      }

      if (NC.datachiusura) {
        NC.datachiusura = moment(NC.datachiusura).format('YYYY-MM-DD');
      }


        // console.log('add NC', NC);

       const response = await AxiosInstance.post('nc/0/',NC);
       return response.data;

      // return AxiosInstance.post('NC/0/',mapNCToJson(NC));
    },

     onSuccess: async (data, variables) => {

         queryClient.invalidateQueries({ queryKey: ['fetchNCDTO'] });

   }, //refetch VersoOre after mutation, disabled for demo
     });
}

 export function useUpdateNC() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (nc: NC) => {
     if (nc.dataapertura) {
        nc.dataapertura = moment(nc.dataapertura).format('YYYY-MM-DD');
      }

      if (nc.datachiusura) {
        nc.datachiusura = moment(nc.datachiusura).format('YYYY-MM-DD');
      }

        const response = await AxiosInstance.patch('nc/'+nc.idnc+'/',nc);
        return response.data;
    },
    onSuccess: async (data, variables) => {
        queryClient.invalidateQueries({ queryKey: ['fetchNCDTO'] });

    },
  });
}





export function useDeleteNC() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (idnc: number) => {


    const response = await AxiosInstance.delete('nc/'+idnc+'/');
     return  response.data
    },
     onSuccess: async (data, variables) => {
      queryClient.invalidateQueries({ queryKey: ['fetchNCDTO'] });
    },
  });
}



export function useGetDropCatNC() {
  return useQuery<DropAttivitaApiResponse>({
    queryKey: ['fetchuseGetDropCatNC'],
    queryFn: async () => {
      const response = await AxiosInstance.get('dropcatnc/?limit=10000&offset=0');
      return response.data
    },
    refetchOnWindowFocus: false,
  });
}


export function useGetDropStatiNC() {
  return useQuery<DropAttivitaApiResponse>({
    queryKey: ['fetchuseGetDropStatiNC'],
    queryFn: async () => {
      const response = await AxiosInstance.get('dropstatinc/?limit=10000&offset=0');
      return response.data
    },
    refetchOnWindowFocus: false,
  });
}

export function useGetDropLivelliNC() {
  return useQuery<DropAttivitaApiResponse>({
    queryKey: ['fetchuseGetDropLivelliNC'],
    queryFn: async () => {
      const response = await AxiosInstance.get('droplivellinc/?limit=10000&offset=0');
      return response.data
    },
    refetchOnWindowFocus: false,
  });
}














export const validationSchemaNC = Yup.object().shape({
  ditta: Yup.number().required("La ditta è obbligatoria").typeError("La ditta deve essere un numero"),
  coddip: Yup.string().required("Il referente è obbligatorio"),
  titolo: Yup.string().required("Il titolo è obbligatorio"),
  note: Yup.string().nullable(),

  idcatnc: Yup.number().required("La categoria è obbligatoria"),
  idstatonc: Yup.number().required("Lo stato è obbligatorio"),
  idlivellonc: Yup.number().required("Il livello è obbligatorio"),

  dataapertura: Yup.date()
    .required("La data apertura è obbligatoria")
    .typeError("Data apertura non valida"),

  datachiusura: Yup.date()
    .nullable()
    .typeError("Data chiusura non valida"),

  auditor: Yup.string().required("L'auditor è obbligatorio"),
  idprog: Yup.string().nullable(),
});